import React from "react";
import styles from "./AffiliatePage.module.scss";
import { Icon } from "../../atoms/Icon";
import bagLogo from "../../assets/bag.svg";
import dashboardLogo from "../../assets/dashboardFilled.svg";
import eyeLogo from "../../assets/eyeFilled.svg";
import checkLogo from "../../assets/shieldCheckFilled.svg";

export default function FeatureSection() {
  return (
    <div className={styles.featuresSection}>
      <div className={"container"}>
        <div className={styles.featuresDetail}>
          <h1>Video Squirrel</h1>
          <p>
            Convert your influence through your content into instant earnings!
            <br /> <br />
            Video Squirrel gives your video content a direct path to purchase at
            the point of discovery. Once you have partnered with any influencer
            opportunity, your video content is ready to be paired and shared
            across your digital channels. With Video Squirrel acting as an
            in-video point of sale, you can see those sales or commissions come
            in instantly.
          </p>
        </div>
        <div className={styles.featuresContainer}>
          <div className={styles.featuresBox}>
            <img src={bagLogo} />
            <div className={styles.featureContent}>
              <h3>Fast Payouts</h3>
              <p>
                Get paid almost instantly. No need to wait 90 days. No back and
                forth on reporting
              </p>
            </div>
          </div>
          <div className={styles.featuresBox}>
            <img src={eyeLogo} />
            <div className={styles.featureContent}>
              <h3>Transparency</h3>
              <p>
                You can see how your videos perform. No cookie or attribution
                confusion
              </p>
            </div>
          </div>
          <div className={styles.featuresBox}>
            <img src={dashboardLogo} />
            <div className={styles.featureContent}>
              <h3>4x better</h3>
              <p>
                Video engages and converts 4x better than any other content on
                digital
              </p>
            </div>
          </div>
          <div className={styles.featuresBox}>
            <img src={checkLogo} />
            <div className={styles.featureContent}>
              <h3>Stay True</h3>
              <p>
                Stay authentic. Stick to your creativity. Let your content to
                the talking.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
